/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
    Select,
    MenuItem,
    AppBar,
    Toolbar,
    Typography,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function TeacherAdd(props) {
    const { login, onCloseAddPop, tcidParent } = props;
    const token = localStorage.getItem("token");
    const [centers, setCenters] = useState([]);
    const [tcid, setTcid] = useState(tcidParent);
    const [showMemberSearch, setShowMemberSearch] = useState(false);
    const [showProductSearch, setShowProductSearch] = useState(false);
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [pass1, setPass1] = useState("");
    const [active, setActive] = useState("");
    const [grade, setGrade] = useState("");

    const onSubmit = async () => {
        // pr("tcid=" + tcid);
        // pr("name=" + name);
        // pr("pass1=" + pass1);
        // pr("birth=" + birth);
        // pr("sex=" + sex);
        // pr("height=" + height);
        // pr("weight=" + weight);
        let result = await axios.post(configState.api + "/gympass_admin/teacher_add", {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            tcid: tcid,
            name: name,
            phone: phone,
            pass1: pass1,
            active: active,
            grade: grade,
        });
        if (result.data.success !== 1) {
            Swal.fire(result.data.msg);
            return;
        } else {
            Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
                (result) => {
                    onCloseAddPop();
                }
            );
        }
    };

    const onCidChange = (e) => {
        pr("cid change");
    };

    const handleClose = () => { };

    // MemberSearch
    const onShowMemberSearchClick = () => {
        setShowMemberSearch(true);
    };

    const onHideMemberSearchClick = () => {
        setShowMemberSearch(false);
    };

    return (
        <Box>
            {/* 사용자 찾기 */}
            <Dialog
                open={showMemberSearch}
                onClose={() => { }}
                fullWidth={true}
                maxWidth="md"
            >
                <AppBar sx={{ position: "static" }}>
                    <Toolbar>
                        <Box sx={{ flexGrow: 1 }}>
                            <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
                        </Box>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={onHideMemberSearchClick}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
            </Dialog>

            <Box
                css={css`
          padding: 20px 60px;
        `}
            >

                {/* 센터명 */}
                <CenterSelect
                    login={login}
                    tcidParent={tcid}
                    setTcidParent={setTcid}
                />

                {/* 강사명 */}
                <Box
                    css={css`
                        margin-top: 10px;
                    `}
                >
                    <TextField
                        name="name"
                        label="강사명"
                        size="small"
                        sx={{
                            width: "180px",
                        }}
                        autoComplete="off"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    ></TextField>
                </Box>

                {/* 연락처 */}
                <Box
                    css={css`
                        margin-top: 10px;
                    `}
                    display="flex"
                    alignItems="center"
                >
                    <TextField
                        name="phone"
                        label="연락처"
                        size="small"
                        sx={{
                            width: "180px",
                        }}
                        autoComplete="off"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    ></TextField>
                    <Box sx={{ ml: 1 }}>- 없이 숫자만 입력(추후 변경불가)</Box>
                </Box>

                {/* 비밀번호 */}
                <Box
                    display="flex"
                    alignItems="center"
                    css={css`
            margin-top: 10px;
          `}
                >
                    <TextField
                        type="password"
                        name="pass1"
                        label="비밀번호"
                        size="small"
                        sx={{
                            width: "180px",
                        }}
                        autoComplete="off"
                        value={pass1}
                        onChange={(e) => setPass1(e.target.value)}
                    ></TextField>
                    <Box sx={{ ml: 1 }}>4~12자리 영문과 숫자로 입력</Box>
                </Box>

                {/* 강사등급 */}
                <FormControl sx={{ width: '180px', marginTop: '10px' }} size="small">
                    <InputLabel>강사등급</InputLabel>
                    <Select
                        name="education"
                        label="강사등급"
                        onChange={(e) => setGrade(e.target.value)}
                        value={grade}
                    >
                        <MenuItem value="점장">점장</MenuItem>
                        <MenuItem value="트레이너">트레이너</MenuItem>
                    </Select>
                </FormControl>

                {/* 강사활성여부 */}
                <FormControl
                    fullWidth
                    css={css`
            margin-top: 10px;
          `}
                >
                    <FormLabel>강사활성여부</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="active"
                        onChange={(e) => setActive(e.target.value)}
                        value={active}
                    >
                        <FormControlLabel value="Y" control={<Radio />} label="활성화" />
                        <FormControlLabel value="N" control={<Radio />} label="비활성화" />
                    </RadioGroup>
                </FormControl>

                <Box
                    css={css`
            text-align: center;
            margin-top: 30px;
          `}
                >
                    <Button variant="contained" onClick={onSubmit}>
                        등록완료
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        css={css`
              margin-left: 10px;
            `}
                        onClick={onCloseAddPop}
                    >
                        취소
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default TeacherAdd;
